import axios from 'axios'

import {
  type Category,
  type DeleteUnusedGenresResult,
  type EditableCategory,
  type Genre,
  type GenreUsage,
  type Tag,
} from '@/shared/types/musicGroup/musicGroup.type'

export const GenresService = {
  async getAll(): Promise<Genre[]> {
    const { data } = await axios.get('/api/genres')
    return data
  },

  async addGenre(genre: Omit<Genre, '_id'> | Tag): Promise<Genre> {
    const { data } = await axios.post('/api/genres', genre)
    return data
  },

  async updateGenre(genre: Genre): Promise<Genre> {
    const { data } = await axios.put(`/api/genres/${genre._id}`, genre)
    return data
  },

  async deleteGenre(genreId: string): Promise<void> {
    await axios.delete(`/api/genres/${genreId}`)
  },

  async deleteGenresBatch(genreIds: string[]): Promise<void> {
    await axios.delete('/api/genres/batch', { data: genreIds })
  },

  async getGenreUsages(genreId: string): Promise<GenreUsage> {
    const { data } = await axios.get(`/api/genres/${genreId}/usages`)
    return data
  },

  async getUsagesBatch(genreIds: string[]): Promise<GenreUsage> {
    const { data } = await axios.post('/api/genres/usages', genreIds)
    return data
  },

  async getAvailableCategories(
    context: 'ALL' | 'GUEST' | 'EVENT' = 'ALL',
    guestTypeId?: string,
    programId?: string,
  ): Promise<Category[]> {
    const { data } = await axios.get('/api/genres/available-categories', {
      params: { context, guestTypeId, programId },
    })
    return data
  },

  async getAvailableTags(): Promise<Genre[]> {
    const { data } = await axios.get('/api/genres/available-tags')
    return data
  },

  async countUnused(): Promise<number> {
    const { data } = await axios.get('/api/genres/unused/count')
    return data
  },

  async deleteUnused(): Promise<DeleteUnusedGenresResult> {
    const { data } = await axios.delete('/api/genres/unused')
    return data
  },

  async updateGenresCategory(
    tagIds: string[],
    category: Category | EditableCategory,
  ): Promise<void> {
    await axios.post('/api/genres/batch-update-category', {
      tagIds,
      category,
    })
  },
}
